import React from "react";

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, clientName }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-80">
                <h3 className="text-lg font-semibold mb-4 text-center">
                    Supprimer le client
                </h3>
                <p className="mb-6 text-center">
                    Voulez-vous vraiment supprimer le client <strong>{clientName}</strong> ?
                </p>
                <div className="flex justify-between gap-4">
                    <button
                        onClick={onClose}
                        className="flex-1 px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                    >
                        Annuler
                    </button>
                    <button
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                        className="flex-1 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                    >
                        Supprimer
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;
